import PartnerAuthenticatedLayout from "@/Layouts/PartnerAuthenticatedLayout.vue";


const partnerRoutes = [
  {
    path: "/partners/create-account",
    name: "partnerCreateAccount",
    meta: {
      title: "Crear cuenta Partner",
    },
    component: () => import("@/Views/Partners/Auth/CreateAccountView.vue"),
  },
  {
    path: "/partners/login",
    name: "partnerLogin",
    meta: {
      title: "Login Partners",
    },
    component: () => import("@/Views/Partners/Auth/LoginView.vue"),
  },
  {
    path: "/partners/logout",
    name: "partnerLogout",
    meta: {
      title: "Logout Partners",
    },
    component: () => import("@/Views/Partners/Auth/LogoutView.vue"),
  },
  {
    path: "/partners/recovery-password",
    name: "partnerRecoveryPassword",
    meta: {
      title: "Recuperar contraseña",
    },
    component: () => import("@/Views/Partners/Auth/PasswordRecoveryView.vue"),
  },
  {
    path: "/partners/reset-password/:token",
    name: "partnerResetPassword",
    meta: {
      title: "Restablecer contraseña",
    },
    component: () => import("@/Views/Partners/Auth/PasswordResetView.vue"),
    props: true,
  },
  {
    path: "/partner",
    component: PartnerAuthenticatedLayout,
    children: [
      {
        path: "dashboard",
        name: "partnerDashboard",
        meta: {
          title: "Panel Partner",
          requiresPartnerAuth: true,
        },
        component: () => import("@/Views/Partners/Dashboard/PartnerDashboardView.vue"),
      },
      {
        path: "accounts",
        name: "partnerAccounts",
        meta: {
          title: "Partners Accounts",
          requiresPartnerAuth: true,
        },
        component: () => import("@/Views/Partners/Accounts/PartnerAccountsView.vue"),
      },
      {
        path: "users",
        name: "partnerUser",
        meta: {
          title: "Partners Users",
          requiresPartnerAuth: true,
        },
        component: () => import("@/Views/Partners/Users/PartnerUserView.vue"),
      },
      {
        path: "plans",
        name: "partnerPlan",
        meta: {
          title: "Partners Plans",
          requiresPartnerAuth: true,
        },
        component: () => import("@/Views/Partners/Plans/PartnerPlansView.vue"),
      },
      {
        path: "subscription",
        name: "subscription",
        meta: {
          title: "Partner Subscription",
          requiresPartnerAuth: true,
        },
        component: () => import("@/Views/Partners/MembershipPlans/MembershipPlansView.vue"),
      },
    ],
  },
];

export default partnerRoutes;
